<template>
  <div :id="item.name" :class="$style.component" />
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" module>
.component {
  position: relative;
  border-top: 1px solid transparent; // Add hidden border in order for margin-top in sibling elements to be respected

  &:not(:first-of-type) {
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: -2px;
      width: 100%;
      height: 1px;
      background-color: var(--dark-grey);
    }
  }
}
</style>
